/**
 * Profile loader
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app       = require('mag-app'),
    format    = require('cjs-format'),
    preloader = require('spa-preloader'),
    profile   = {};


/**
 * Convert vector to matrix.
 *
 * @param {Array} items list of items
 * @param {number} rows amount of rows in the output matrix
 * @param {number} cols amount of columns in the output matrix
 *
 * @return {Array} output matrix
 */
function paginateItems ( items, rows, cols ) {
    var pageAmount = Math.ceil(items.length / (rows * cols)) || 1,
        pageData   = [],
        itemIndex  = 0,
        iPage, iRow, iCol;

    for ( iPage = 0; iPage < pageAmount; iPage++ ) {
        pageData[iPage] = [];
        for ( iRow = 0; iRow < rows; iRow++ ) {
            pageData[iPage][iRow] = [];
            for ( iCol = 0; iCol < cols; iCol++ ) {
                pageData[iPage][iRow][iCol] = items[itemIndex] || {disable: true};
                itemIndex++;
            }
        }
    }

    return pageData;
}


function processData ( data, apps ) {
    var height      = app.metrics.height,
        categoryMap = {},
        imgLinks    = [],
        groups      = [],
        offset      = 0,
        categoryIndex, appIndex, group, item;

    // correct links
    try {
        data.logo = format(data.logo, height);
    } catch ( error ) {
        console.log(error);
        console.log(data.logo);
    }

    data.categories = data.categories.map(function ( category ) {
        category.apps = [];
        categoryMap[category.name.toLowerCase()] = category;

        return category;
    });

    apps.forEach(function ( currentApp ) {
        if ( categoryMap[currentApp.category] ) {
            categoryMap[currentApp.category].apps.push(currentApp);
        }
    });

    data.categories = data.categories.filter(function ( category ) {
        return category.apps.length;
    });

    // groups
    for ( categoryIndex = 0; categoryIndex < data.categories.length; categoryIndex++ ) {
        group = data.categories[categoryIndex];

        switch ( group.name ) {
            case 'media':
                group.name = gettext('Media');
                break;

            case 'apps':
                group.name = gettext('Apps');
                break;

            case 'games':
                group.name = gettext('Games');
                break;

            default:
                group.name = gettext(group.name);
                break;
        }

        group.offset = offset;

        // correct links
        imgLinks.push(group.icons = format(group.icons, height));

        // group items
        for ( appIndex = 0; appIndex < group.apps.length; appIndex++ ) {
            item = group.apps[appIndex];
            // correct links
            item.icon = item.uris.icons.logoNormal || group.icons;
            item.focusIcon = item.uris.icons.logoActive || group.icons;

            imgLinks.push(item.icon);
            imgLinks.push(item.focusIcon);
        }

        // convert vector to matrix
        group.apps = paginateItems(group.apps, app.metrics.appMenuRows, app.metrics.appMenuCols);

        offset = offset + group.apps.length;
        groups.push(group);
    }

    data.menu = groups;

    preloader.add(imgLinks);

    return data;
}


function getAppPackages ( data ) {
    return processData(data, core.packages.filter(function ( corePackage ) {
        return corePackage.type === 'app';
    }));
}


profile.load = function ( args, callback ) {
    var url = args.config || 'config.json',
        xhr = new XMLHttpRequest(),
        alias;

    if ( MODE === 'PORTAL' ) {
        xhr.onload = function () {
            var error = false,
                data  = {};

            console.log('onload');

            try {
                console.log(xhr.responseText);
                data = JSON.parse(xhr.responseText);

                Object.keys(args).forEach(function ( param ) {
                    if ( param !== 'config' ) {
                        data[param] = args[param];
                    }
                });

                data = getAppPackages(data);

                callback(null, data);
            } catch ( exceptionError ) {
                console.log(exceptionError);
                error = exceptionError.toString() + ' <br>url: ' + url;
            }

            callback(error, data);
        };

        xhr.onerror = function () {
            console.log('onerror');
            callback('url: ' + url);
        };

        xhr.ontimeout = function () {
            console.log('ontimeout');
            callback('url: ' + url);
        };

        xhr.open('GET', url, true);
        xhr.send(null);
    } else {
        alias = core.backend.settings.theme;

        if ( core.backend.settings.themes[alias] && core.backend.settings.themes[alias].alias ) {
            alias = core.backend.settings.themes[alias].alias;
        } else {
            alias = 'default';
        }

        core.backend.request('themes/' + alias + '?colorSpace=rgba_hex&screenResolution=' + screen.width + 'x' + screen.height, {
            onload: function ( error, response ) {
                var data = {
                    logo: 'img/{0}/logo.png',
                    categories: [
                        {
                            name: 'Media',
                            icons: 'img/{0}/icons/media.png',
                            color: '#ffd200',
                            apps: []
                        },
                        {
                            name: 'Apps',
                            icons: 'img/{0}/icons/apps.png',
                            color: '#00eaff',
                            apps: []
                        },
                        {
                            name: 'Games',
                            icons: 'img/{0}/icons/games.png',
                            color: '#8de619',
                            apps: []
                        }
                    ]
                };

                if ( !error && response.data ) {
                    if ( response.data.logoFilename ) {
                        data.logo = response.data.logoFilename.value;
                    }

                    if ( response.data.logoAlign ) {
                        data.logoAlign = response.data.logoAlign.value;
                    }
                }

                callback(null, getAppPackages(data));
            },
            onerror: function () {
                var data = {
                    logo: 'img/{0}/logo.png',
                    categories: [
                        {
                            name: 'Media',
                            icons: 'img/{0}/icons/media.png',
                            color: '#ffd200',
                            apps: []
                        },
                        {
                            name: 'Apps',
                            icons: 'img/{0}/icons/apps.png',
                            color: '#00eaff',
                            apps: []
                        },
                        {
                            name: 'Games',
                            icons: 'img/{0}/icons/games.png',
                            color: '#8de619',
                            apps: []
                        }
                    ]
                };

                data = getAppPackages(data);

                callback(null, data);
            }
        });
    }
};

if ( DEVELOP ) {
    // expose to the global scope
    window.profile = profile;
}

// public
module.exports = profile;
